import { useMemo } from 'react';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useBacklogSelector } from '../../../state/index.tsx';
import {
	getProjectName,
	projectIdSelector,
	getProjects,
} from '../../../state/selectors/app/index.tsx';
import { useGetSpaceKey } from './utils.tsx';

export const useCoUseFlow = (coUseEligible: boolean): string => {
	const projects = useBacklogSelector(getProjects);
	const projectId = useBacklogSelector(projectIdSelector);
	// In company managed projects project name is actually the project key, that's why we cannot rely on it to search for a space, we will still default to it if no project matches are found.
	const projectName = useBacklogSelector(getProjectName);
	const project = useMemo(
		() => projects?.find?.((it) => it.id === projectId),
		[projects, projectId],
	);
	const name = project?.name ?? projectName;

	const spaceKey = useGetSpaceKey(name, coUseEligible);

	const cloudId = useCloudId();

	return `/wiki/create-content/whiteboard?openJiraImportTool=true&cloudId=${cloudId}&projectUuid=${projectId}&insertTemplateWithKey=prioritization-experiment&spaceKey=${spaceKey}&withFallback=True`;
};
